import { render } from "./MDetails.vue?vue&type=template&id=a4b49ee2&scoped=true"
import script from "./MDetails.vue?vue&type=script&lang=js"
export * from "./MDetails.vue?vue&type=script&lang=js"

import "./MDetails.vue?vue&type=style&index=0&id=a4b49ee2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4b49ee2"]])

export default __exports__